import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { Expose, Model, ModelId } from '@core/shared/model';
import { PaymentReminderInteractionItem } from '../models';
import { AppRequestMethod } from '@core/shared/request';
let StorePaymentReminderInteractionResponse = /*#__PURE__*/(() => {
  let StorePaymentReminderInteractionResponse = class StorePaymentReminderInteractionResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", PaymentReminderInteractionItem)], StorePaymentReminderInteractionResponse.prototype, "interaction", void 0);
  StorePaymentReminderInteractionResponse = __decorate([ModelId("StorePaymentReminderInteractionResponse") // auto-generated by generate-model-ids
  ], StorePaymentReminderInteractionResponse);
  return StorePaymentReminderInteractionResponse;
})();
export { StorePaymentReminderInteractionResponse };
let StorePaymentReminderInteractionRequest = /*#__PURE__*/(() => {
  let StorePaymentReminderInteractionRequest = class StorePaymentReminderInteractionRequest extends Model {
    static {
      this.Response = StorePaymentReminderInteractionResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", String)], StorePaymentReminderInteractionRequest.prototype, "reaction", void 0);
  __decorate([Expose(), __metadata("design:type", Number)], StorePaymentReminderInteractionRequest.prototype, "reminderId", void 0);
  StorePaymentReminderInteractionRequest = __decorate([AppRequest('payment-reminder', 'store-interaction', {
    httpMethod: AppRequestMethod.POST,
    requiredAccessData: ['userId']
  }), ModelId("StorePaymentReminderInteractionRequest") // auto-generated by generate-model-ids
  ], StorePaymentReminderInteractionRequest);
  return StorePaymentReminderInteractionRequest;
})();
export { StorePaymentReminderInteractionRequest };